import { render } from "./CartProductCard.vue?vue&type=template&id=2a42b6ef"
import script from "./CartProductCard.vue?vue&type=script&lang=js"
export * from "./CartProductCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__